import { render, staticRenderFns } from "./Promotion.vue?vue&type=template&id=fd6bb8c4&scoped=true"
import script from "./Promotion.vue?vue&type=script&lang=js"
export * from "./Promotion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6bb8c4",
  null
  
)

export default component.exports